const STATUS_PRIORITY = {
  healthy: 0,
  unknown: 1,
  stale: 2,
  warning: 3,
  critical: 4
}

export function normalizeStatus (status) {
  const normalized = String(status || '').toLowerCase()
  if (STATUS_PRIORITY[normalized] !== undefined) {
    return normalized
  }
  return 'unknown'
}

export function statusColor (status) {
  const normalized = normalizeStatus(status)
  switch (normalized) {
    case 'healthy':
      return 'success'
    case 'warning':
      return 'warning'
    case 'critical':
      return 'error'
    case 'stale':
      return 'grey'
    case 'unknown':
    default:
      return 'grey lighten-1'
  }
}

export function statusIcon (status) {
  const normalized = normalizeStatus(status)
  switch (normalized) {
    case 'healthy':
      return 'fal fa-circle-check'
    case 'warning':
      return 'fal fa-triangle-exclamation'
    case 'critical':
      return 'fal fa-circle-exclamation'
    case 'stale':
      return 'fal fa-hourglass-clock'
    case 'unknown':
    default:
      return 'fal fa-circle-question'
  }
}

export function statusLabel (status) {
  const normalized = normalizeStatus(status)
  switch (normalized) {
    case 'healthy':
      return 'Healthy'
    case 'warning':
      return 'Warning'
    case 'critical':
      return 'Critical'
    case 'stale':
      return 'Stale'
    case 'unknown':
    default:
      return 'Unknown'
  }
}

export function getWorstStatus (statuses) {
  let winner = 'healthy'
  let winnerScore = STATUS_PRIORITY[winner]

  ;(statuses || []).forEach(function (status) {
    const normalized = normalizeStatus(status)
    const score = STATUS_PRIORITY[normalized]
    if (score > winnerScore) {
      winner = normalized
      winnerScore = score
    }
  })

  return winner
}

export function formatAgeShort (ageSeconds) {
  if (ageSeconds === null || ageSeconds === undefined || isNaN(Number(ageSeconds))) {
    return '-'
  }

  const seconds = Math.max(0, Math.round(Number(ageSeconds)))
  if (seconds < 60) {
    return seconds + 's'
  }

  const minutes = Math.floor(seconds / 60)
  const remainderSeconds = seconds % 60
  if (minutes < 60) {
    return minutes + 'm ' + remainderSeconds + 's'
  }

  const hours = Math.floor(minutes / 60)
  const remainderMinutes = minutes % 60
  return hours + 'h ' + remainderMinutes + 'm'
}

export function boolLabel (value, trueLabel, falseLabel) {
  return value ? trueLabel : falseLabel
}
